// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

export const SERVER_API_URL = "http://weyouthorganization.org/api/public/";
//http://weyouthorganization.org/api/public/
//http://localhost/projects/laravel_backend/public/
//http://localhost:82/backend/public/